/**
 * FailEvaluator — PURE light-fail decision for the Phase 5 flow model.
 *
 * Design (user-approved): a puzzle "fails light" (retry-from-checkpoint, no
 * game-over) when Basil's harness integrity reaches zero OR an escort convoy
 * is irrecoverably lost. Harness failure takes precedence so the HUD message
 * and telemetry reason are deterministic when both conditions hold in the same
 * frame.
 *
 * No Babylon / EventBus imports — callers feed scalars and react to the result.
 */
export type FailReason = 'harness' | 'escort' | null;

export interface FailInput {
  /** Basil harness integrity, 0..max. */
  harnessIntegrity: number;
  /** True when an escort convoy can no longer be reclaimed. */
  escortLost: boolean;
}

export function evaluateFail(i: FailInput): FailReason {
  if (i.harnessIntegrity <= 0) return 'harness';
  if (i.escortLost) return 'escort';
  return null;
}
